import React from "react";
import Router from "next/router";
import WalletBalanceHeader from "./WalletBalanceHeader";
import Withdrawal from "central-payment/Main/Web/M23/Withdrawal";
import { Modal, Button, message } from "antd";
import AddWalletAddress from "@/BankAccount/AddWalletAddress";
import PhoneVerify from "@/Verification/PhoneVerify";
import ExceedVerify from "@/OTP/ExceedVerify";
import Announcement from "@/Announcement/";
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort, APISET, API8SET } from "$ACTIONS/TLCAPI";
import AccountVerification from "@/Wallet/withdrawComponents/AccountVerification";
import AddBankCard from "@/BankAccount/AddBankCard";
import { connect } from "react-redux";
import { getMemberInfoAction } from "$STORE/thunk/memberThunk";
import { getBalanceInfoAction } from "$STORE/thunk/balanceThunk";
import { getE2BBValue } from "$ACTIONS/helper";
import HostConfig from "$ACTIONS/Host.config";
const { LocalHost, HostApi, BFFSCApi } = HostConfig.Config;
import {
    setFEWalletParams,
    setFEWalletParam,
} from "central-payment/platform.pay.config";
import { getSeonSession } from "$ACTIONS/util";

//在 withdrawal module 使用 BFFSC 的api
export const paymentFebffsc = [
    "/api/Member",
    "/api/Verification/AccountHolderName",
];
class WithdrawalWrap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currKey: "", //當前提款方法
            payMethods: [], //提款方法列表 (LB、CCW)
            addWalletAddressVisible: false, //添加 ctc address 彈窗
            ctcType: "", //當前添加 wallet address ctc 類別
            exceedVisible: "", //超過驗證次數彈窗
            checkAbleSmsOTP: {
                isAbleSmsOTP: false, // OTP驗證
                attempts: 0, // 剩餘次數
            },
            phoneVisible: false,
            accountVerificationType: "", //1st 提款驗證 : All、Email、Phone,
            showAnnouncement: false,
        };
        this.getmemberInfo = this.getmemberInfo.bind(this); // 獲取會員訊息
        this.openAccountVerification = this.openAccountVerification.bind(this); // 1st 提款驗證
        this.VerifyCategory = this.VerifyCategory.bind(this); // 切換驗證方式(for添加ctc address)
        this.judgeOTPVerification = this.judgeOTPVerification.bind(this); // 查询会员是否能够请求短信OTP
        this.setPhoneAttemptRemaining = this.setPhoneAttemptRemaining.bind(this); // 修改剩餘次數

        //中心支付配置
        this.privateParams = {
            device: "WEB",
            platformType: "F1",
            languageType: "M2",
            domainName: LocalHost,
            successUrl: LocalHost,
            ActiveMethods: "", //指定存款,默认第一个
            bonusId: 0,
            bonusName: "",
            depositingWallet: "",
            firstName: "",
            e2Backbox: getE2BBValue() || "",
            BackClick: () => {
                this.props.onCancel(); //關閉錢包彈窗
                // setTimeout(() => {
                //     Router.push("/");
                // }, 1500);
            },
            ApiDomain: HostApi,
            getSeonSession: getSeonSession,
            ApiGet: (url) => {
                const baseUrl = url.split("?")[0];
                const apis = paymentFebffsc.includes(baseUrl) ? BFFSCApi : HostApi;
                const apiVersion = (paymentFebffsc.includes(baseUrl) ? API8SET : APISET).slice(1);
                return get(apis + url + apiVersion);
            },
            ApiPost: (url, postdata) => {
                const baseUrl = url.split("?")[0];
                const apis = paymentFebffsc.includes(baseUrl) ? BFFSCApi : HostApi;
                const apiVersion = (paymentFebffsc.includes(baseUrl) ? API8SET : APISET).slice(1);
                return post(
                    apis + url + apiVersion,
                    postdata
                );
            },
            goDeposit: () => {
                global.showDialog({ key: 'wallet:{"type": "deposit"}' }); //去存款
            },
            goVerifyContact: (type) => {
                this.openAccountVerification(type); //1st提款 手機、信箱驗證，type: All、Email、Phone
            },
            goFinishKYCInfo: () => {
                this.props.onCancel(); //關閉錢包彈窗
                this.props.goUserCenter("upload-files");
            },
            goFinishMemberInfo: () => {}, //存款真實姓名驗證

            //添加銀行
            goAddBankInfo: (withdrawType, ctcType, getList) => {
                if (withdrawType === "usdt") {
                    this.judgeOTPVerification(ctcType);
                    this.getTDBWallet = getList;
                } else if (withdrawType === "bank") {
                    this.addBankCard();
                    this.getBankCard = getList;
                }
            },
            //刷新餘額
            reloadBalance: () => {
                this.props.getBalanceInfo();
            },
            //聯繫客服
            LivechatClick: () => {
                global.PopUpLiveChat();
            },
            openService: () => {
                global.PopUpLiveChat();
            },

            //歷史紀錄，type = deposit存款记录, withdraw提款记录
            goRecord: () => {
                this.goRecords("withdraw");
            },

            toastTip: {
                loading: (str) => {
                    this.props.setLoading(true, str);
                },
                success: (str) => {
                    message.success(str);
                },
                error: (str) => {
                    message.error(str);
                },
                hide: () => {
                    this.props.setLoading(false);
                },
            },
            modalTip: {
                info: (info) => {
                    Modal.info({
                        icon: null,
                        centered: true,
                        title: info.title,
                        okText: info.okBtnTxt,
                        content: info.children,
                        onOk: () => {
                            info.okFunction && info.okFunction();
                        },
                        width: 400,
                        className: `info-general-modal  ${info.wrapClassName}`,
                    });
                },
                confirm: (info) => {
                    Modal.confirm({
                        icon: null,
                        centered: true,
                        title: info.title,
                        okText: info.okBtnTxt,
                        cancelText: info.noBtnTxt,
                        content: info.children,
                        onOk: () => {
                            info.okFunction && info.okFunction();
                        },
                        onCancel: () => {
                            info.noFunction && info.noFunction();
                        },
                        width: 400,
                        className: `confirm-general-modal ${info.wrapClassName}`,
                        cancelButtonProps: info.onlyOKBtn
                            ? { style: { display: "none" } }
                            : {},
                    });
                },
            },
            siteId: 37,
            webPiwikEvent: (
                eventCategory,
                action,
                name,
                value = false,
                customVariableArr = []
            ) => {
                Pushgtagdata(
                    eventCategory,
                    action,
                    name,
                    value,
                    customVariableArr
                );
            },
            webPiwikUrl: (
                url,
                trackingTitle = false,
                isTrackPageView = true,
                isOnlyBaseUrl = false
            ) => {
                Pushgtagpiwikurl(
                    url,
                    trackingTitle,
                    isTrackPageView,
                    isOnlyBaseUrl
                );
            },
            appPiwikEvent: () => {},
            appPiwikUrl: () => {},
        };
        setFEWalletParams(this.privateParams);
    }
    componentDidMount() {
        if (JSON.stringify(this.props.memberInfo) === "{}") {
            this.getmemberInfo();
        }
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("withdrawal", "Withdrawal");
    }
    componentDidUpdate(prevProps, prevState) {
        if (typeof this.props.setCurrKey === "function") {
            if (prevState.currKey !== this.state.currKey) {
                this.props.setCurrKey(this.state.currKey);
            }
            if (prevState.payMethods.length !== this.state.payMethods.length) {
                this.props.setPayMethods(this.state.payMethods);
            }
        }
        if (
            prevProps.currentWithdrawKey !== this.props.currentWithdrawKey &&
            this.props.currentWithdrawKey
        ) {
            this.payChange(this.props.currentWithdrawKey); //切換提款方法
        }
    }
    // 獲取會員訊息
    getmemberInfo() {
        this.props.setLoading(true);
        this.props.getMemberInfo((res) => {
            this.props.setLoading(false);
        });
    }
    judgeOTPVerification(ctcType, callback) {
        // 查询会员是否能够请求短信OTP
        this.props.setLoading(true);
        get(ApiPort.CheckIsAbleSmsOTP)
            .then((res) => {
                this.props.setLoading(false);
                if (ctcType) {
                    this.setState({
                        ctcType: ctcType,
                    });
                }
                if (
                    res?.isSuccess &&
                    res?.result?.isAbleSmsOTP &&
                    res?.result?.attempts
                ) {
                    if (!this.state.addWalletAddressVisible) {
                        this.setState({ addWalletAddressVisible: true });
                    }
                    this.setState({
                        checkAbleSmsOTP: {
                            isAbleSmsOTP: res.result.isAbleSmsOTP,
                            attempts: res.result.attempts,
                        },
                    });
                    // sms 和 voice 切換，確認剩餘次數
                    typeof callback === "function" && callback(res.result.attempts);
                } else {
                    // 關閉電話驗證彈窗，彈窗超過次數
                    this.setState({
                        exceedVisible: true,
                        addWalletAddressVisible: false,
                        phoneVisible: false,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    openAccountVerification = (type) => {
        this.setState({ accountVerificationType: type });
    };
    VerifyCategory = (
        exceedVisible,
        walletVisible,
        phoneVisible,
    ) => {
        this.setState({
            exceedVisible: exceedVisible,
            addWalletAddressVisible: walletVisible,
            phoneVisible: phoneVisible,
        });
    };
    setPhoneAttemptRemaining = (e) => {
        // 修改剩餘次數
        this.setState({
            checkAbleSmsOTP: { ...this.state.checkAbleSmsOTP, attempts: e },
        });
    };
    goRecords = (recordType) => {
        let PAGE_TARGET = "transaction-record";
        sessionStorage.setItem("selectTabKey", recordType); //選擇 存款、提款 tab
        if (~window.location.pathname.indexOf("/th/transaction-record")) {
            this.props.onCancel(); //關閉錢包彈窗
            typeof global.changeRecordFilterType === "function" &&
                global.changeRecordFilterType(recordType);
        } else {
            Router.push("/transaction-record");
        }
    };
    addBankCard = () => {
        this.setState({ addBankVisible: true });
    };
    render() {
        const {
            addWalletAddressVisible,
            ctcType,
            exceedVisible,
            checkAbleSmsOTP,
            phoneVisible,
            accountVerificationType,
            showAnnouncement,
        } = this.state;
        const { memberInfo } = this.props;
        setFEWalletParam("firstName", memberInfo?.firstName || "");
        return (
            <React.Fragment>
                <WalletBalanceHeader />
                {memberInfo != "" && (
                    <Withdrawal
                        setPayMethods={(list) => {
                            this.setState({ payMethods: list });
                        }}
                        setPayMethodChange={(run) => {
                            this.payChange = run;
                        }}
                        setCurrKey={(v) => {
                            this.setState({ currKey: v });
                        }}
                        setAnnouncement={(showAnnouncement) => {
                            this.setState({ showAnnouncement });
                        }}
                    />
                )}
                {/* 添加 USDT 驗證 */}
                {phoneVisible && (
                    <PhoneVerify // 手機驗證
                        GetThroughoutVerification={() => {
                            global.GetThroughoutVerification();
                        }}
                        memberInfo={memberInfo && memberInfo}
                        visible={phoneVisible}
                        closeModal={() =>
                            this.setState({ phoneVisible: false })
                        }
                        phone={
                            memberInfo.isVerifiedPhone &&
                            memberInfo.isVerifiedPhone[0]
                        }
                        otpParam={`cry-otp`}
                        kindOfVerifications={"CryptoWallet"}
                        changeVerify={this.VerifyCategory}
                        modalTitle={`ยืนยันข้อมูลเบอร์โทรศัพท์`} //手机验证
                        times={5}
                        phoneattemptRemaining={checkAbleSmsOTP?.attempts}
                        setPhoneAttemptRemaining={this.setPhoneAttemptRemaining}
                        judgeOTPVerification={this.judgeOTPVerification}
                        submitAddWalletAddress={this.submitAddWalletAddress}
                        isAllowChange={false}
                    />
                )}
                {/* 添加 USDT 钱包地址 */}
                {addWalletAddressVisible && (
                    <AddWalletAddress
                        addWalletAddressVisible={addWalletAddressVisible}
                        closeAddwallet={() => {
                            this.setState({ addWalletAddressVisible: false });
                        }}
                        ctcMethod={ctcType}
                        setLoading={this.props.setLoading}
                        submitAddWalletAddress={(run) => {
                            this.submitAddWalletAddress = run;
                        }}
                        changeVerify={this.VerifyCategory}
                        openOTP={() => {
                            this.setState({
                                phoneVisible: true,
                            });
                        }}
                        getTDBWallet={this.getTDBWallet}
                    />
                )}
                {/* 1st提款，信箱、手機驗證 */}
                <AccountVerification
                    closeWallet={(v) => {
                        this.props.onCancel();
                    }}
                    otpParam={`withdrawal-otp`}
                    memberInfo={memberInfo}
                    correctMemberInfo={this.getmemberInfo}
                    accountVerificationType={accountVerificationType}
                    GetThroughoutVerification={() => {
                        global.GetThroughoutVerification();
                    }}
                />
                {/* otp 超過次數彈窗 */}
                <ExceedVerify
                    exceedVisible={exceedVisible}
                    times={5}
                    headTitle={"ยืนยันข้อมูลเกินที่กำหนด"} //`添加 ${ctcType} 钱包地址`
                    onCancel={() => {
                        this.setState({
                            exceedVisible: false,
                            addWalletAddressVisible: false,
                        });
                    }}
                    otpParam={`cry-otp`}
                />
                {/* 添加銀行卡 */}
                {this.state.addBankVisible && (
                    <AddBankCard
                        visible={this.state.addBankVisible}
                        closeModal={() => {
                            this.setState({ addBankVisible: false });
                        }}
                        getMemberBanksList={() => {
                            this.getBankCard();
                        }}
                        memberInfo={memberInfo}
                        selectedType={"W"}
                    />
                )}
                {/* 紧急公告弹窗 */}
                {showAnnouncement && <Announcement optionType="Withdrawal" />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    memberInfo: state.userCenter.memberInfo,
});

const mapDispatchToProps = {
    getMemberInfo: (callback, refresh) =>
        getMemberInfoAction(callback, refresh),
    getBalanceInfo: () => getBalanceInfoAction(),
};

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalWrap);
